import { createFileRoute } from '@tanstack/react-router';

type Search = {
  type?: 'google' | 'facebook' | 'private';
};

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/reviews/$site')({
  staticData: { team: 'fe-messaging' },
  validateSearch: (search: Search): Search => {
    return {
      type: search?.type,
    };
  },
});
